module.exports = __webpack_public_path__ + "img/button-shop.2061cf21.png";